/**
 * @components trialStudy
 * @author 陈恩浩
 */

import React, { Component } from "react";
import { Button, Input, message, Modal } from "antd";
import "./index.scss";
import { postSignup } from "src/apis/user";
import { regEmail } from "@/utils/util";

import { changePopup, changeMenu } from "src/redux/basicInfo";
import { connect } from "react-redux";
import { Select } from "antd";
import area from "@/utils/area";
import { SendSms } from "@/apis/user";

const { Option } = Select;

@connect((state) => state, { changePopup, changeMenu })
class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        name: "",
        phone: "",
        phoneCode: "", // 区号
        verifyCode: "88888888",
        contact: "",
        email: "",
        country: "",
      },

      emailStatus: false,

      count: 0,
      value: 1,
      loading: false,
    };
  }

  componentDidMount() {}

  /*
  选择国家 start
  */

  onSelectChange = (value) => {
    let phoneCode = value.split("+")[1],
      // country = value,
      form = this.state.form;
    this.setState({ form: { ...form, phoneCode } });
  };

  getUrlParam = (name) => {
    // 取得url中?后面的字符
    var query = window.location.hash.split("?")[1];
    // 把参数按&拆分成数组
    var param_arr = query ? query.split("&") : "";
    for (var i = 0; i < param_arr.length; i++) {
      var pair = param_arr[i].split("=");
      if (pair[0] == name) {
        return pair[1];
      }
    }
    return false;
  };

  handleSend = () => {
    let { phone, phoneCode } = this.state.form;
    if ((phone, phoneCode)) {
      if (this.state.count === 0) {
        SendSms({ phone, phoneCode }).then((res) => {
          // console.log(res);
          let count = 60;
          this.setState({ count: 60 });
          let timer = setInterval(() => {
            this.setState({ count: count-- });
            if (this.state.count === 0) {
              clearInterval(timer);
            }
          }, 1000);
        });
      }
    } else {
      message.error("请先完善 国家及地区 / 手机号");
    }
  };

  /*
  选择国家 end
  */
  handleVerify = (e) => {
    let verifyCode = e.target.value,
      form = this.state.form;
    this.setState({ form: { ...form, verifyCode } });
  };

  handlePhone = (e) => {
    let phone = e.target.value,
      form = this.state.form;
    this.setState({ form: { ...form, phone } });
  };
  handleArea = (e) => {
    // console.log(e.target.value);
    let country = e.target.value,
      form = this.state.form;
    this.setState({ form: { ...form, country } });
  };
  handleApp = (e) => {
    let contact = e.target.value,
      form = this.state.form;
    this.setState({ form: { ...form, contact } });
  };

  handleName = (e) => {
    let name = e.target.value,
      form = this.state.form;
    this.setState({ form: { ...form, name } });
  };

  handleEmail = (e) => {
    let email = e.target.value,
      form = this.state.form;
    if (regEmail(email)) {
      this.setState({
        emailStatus: false,
      });
    } else {
      this.setState({
        emailStatus: true,
      });
    }
    this.setState({ form: { ...form, email } });
  };

  handleSubmit = () => {
    let { name, phone, phoneCode, verifyCode, contact, email, country } =
      this.state.form;
    let { emailStatus } = this.state;
    let data = {
      name,
      phone,
      phoneCode,
      verifyCode,
      contact,
      email,
      emailStatus,
      channelId: this.getUrlParam("channelId") || null,
      activityId: this.getUrlParam("activityId") || null,
      userId: this.getUrlParam("userId") || null,
      country,
    };
    if (this.getUrlParam("channelId") && this.getUrlParam("activityId")) {
      data.channelId = this.getUrlParam("channelId");
      data.activityId = this.getUrlParam("activityId");
      data.applySource = 6;
    } else {
      data.applySource = 5;
    }
    // if (phone && contact && name && email && phoneCode && verifyCode) {
      if (phone && name && phoneCode && verifyCode && contact) {
      if (!emailStatus || !email) {
        this.setState({ loading: true });
        postSignup(data)
          .then((res) => {
            this.setState({ loading: false });
            if (res.code === 200) {
              // Modal.info({
              //   title: "消息",
              //   content: <div>提交成功</div>,
              // });
              this.props.changePopup({ type: "", status: false });
              this.props.history.push({
                pathname: "/result",
              });
            }
          })
          .catch(() => {
            this.setState({ loading: false });
          });
      } else {
        this.setState({ loading: false });
        message.error("邮箱格式不对");
      }
    } else {
      let errMessage = '信息不得为空'
        if(!contact){
          errMessage = '微信号不能为空'
        }
        if(!phone){
          errMessage = '手机号不能为空'
        }
        if(!phoneCode){
          errMessage = '区号不能为空'
        }
        if(!name){
          errMessage = '姓名不能为空'
        }
      message.error(errMessage);
    }
  };

  onChange = (e) => {
    // console.log("radio checked", e.target.value);
    this.setState({
      value: e.target.value,
    });
  };

  onFinish = (values) => {
    // console.log("Received values of form: ", values);
  };

  render() {
    const { emailStatus, count, loading } = this.state;
    return (
      <div className="login">
        <div className="login-title" style={{ border: 0 }}>
          申请免费试读
        </div>
        <div className="login-layout">
          <Input
            className="text"
            placeholder="姓名 / Name"
            onChange={this.handleName}
          />
        </div>
        <div className="login-layout-extra"></div>
        <div className="login-layout">
          {/* <div className="text" style={{ width: "160px" }}>
            居住国 / Country
          </div> */}
          <Select
            showSearch
            style={{
              width: 180,
              backgroundColor: "none",
              lineHeight: "120px",
              cursor: "pointer",
            }}
            onChange={this.onSelectChange}
            placeholder="请选择地区"
          >
            {area.map((item, index) => (
              <Option
                key={index}
                value={
                  item.country_name_cn +
                  "(" +
                  item.ab +
                  ")+" +
                  item.country_code
                }
              >
                {item.country_name_cn}({item.ab}) +{item.country_code}
              </Option>
            ))}
          </Select>
          <Input
            maxLength={20}
            className="phone"
            placeholder="手机号 / Phone"
            onChange={this.handlePhone}
          />
        </div>
        <div className="login-layout-extra"></div>
        <div className="login-layout areaPhone">
          <Input
            className="text"
            placeholder="请输入地区"
            onChange={this.handleArea}
          />
        </div>
        <div className="login-layout-extra"></div>
        {/* <div className="login-layout">
          <Input
            className="text"
            placeholder="验证码 / verify Code"
            maxLength="6"
            onChange={this.handleVerify}
          />
          <div className="login-verify" onClick={this.handleSend}>
            {count ? count + " s" : "发送验证码"}
          </div>
        </div>
        <div className="login-layout-extra"></div> */}
        <div className="login-layout">
          <Input
            className="text"
            placeholder="微信 / Wachat"
            onChange={this.handleApp}
          />
        </div>

        <div className="login-layout-extra"></div>
        <div className="login-layout">
          <Input
            className="text"
            placeholder="邮箱 / Email"
            onChange={this.handleEmail}
          />
        </div>
        <div className="login-layout-extra">
          {emailStatus && (
            <div className="login-prompt" style={{ color: "#ee5252" }}>
              {" "}
              请检查邮箱格式
            </div>
          )}
        </div>
        <Button
          className="login-button login-submit"
          onClick={this.handleSubmit}
          loading={loading}
        >
          提交申请
        </Button>
        <div className="login-layout-extra"></div>
      </div>
    );
  }
}

export default Register;
